import {JourneyProgressCard} from "~/components/journeyProgressCard";
import type {CustomerProfileLifecycleItem} from "~/components/entityProfile/lifecycle/types";

export function ProfileCustomerLifecycleCards({
    lifecycles,
    highlightActiveSelection = false,
}: {
    lifecycles: CustomerProfileLifecycleItem[];
    highlightActiveSelection?: boolean;
}) {
    if (lifecycles.length === 0) {
        return null;
    }

    return (
        <div className="grid gap-y-ds-space-150">
            {lifecycles.map((lifecycle) => {
                const {id, ...cardProps} = lifecycle;
                return (
                    <JourneyProgressCard
                        key={id}
                        {...cardProps}
                        isSelected={highlightActiveSelection === true && lifecycle.status === "active"}
                    />
                );
            })}
        </div>
    );
}
